import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg width="10" height="17" viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg" {...this.props}><path d="M1.211 16l7.213-7.391L1 1" strokeWidth="2" stroke="#FFF" fill="none" fillRule="evenodd" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/static/images/action-bar-arrow-right.svg